/**
 * The custom error to be thrown when a rollout is not found.
 */
export class NotFoundError extends Error {
    constructor(name: string) {
        super();
        this.message = `The rollout ${name} was not found. Make sure its created in the dashboard. The default value was returned.`;
    }
}
